module.exports = __webpack_public_path__ + "img/Ice cream Icon - charcoal.e40a7e8e.svg";